// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Google OAuth Configuration
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '489949596828-f35084433cn1ejvdd9r38n6vetarp4sp.apps.googleusercontent.com';

// Microsoft OAuth Configuration (optional)
export const MICROSOFT_CLIENT_ID = process.env.REACT_APP_MICROSOFT_CLIENT_ID || '';

// BigQuery Configuration
// Note: Project ID is public but dataset/table names should stay private
export const BIGQUERY_CONFIG = {
  PROJECT: process.env.REACT_APP_GCP_PROJECT || 'crypto-iris-482914-u4',
  DATASET: 'Dashboards',
  TABLE: 'DEMOGRAPHICS_PY'
};
